import * as React from "react";
import Container from "@mui/material/Container";
import {
  Typography,
  Box,
  Grid,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import { gold, ButtonBrand } from "../../../../getLPTheme";
import { options } from "@config";

type Subscription = {
  is_active?: boolean;
  status?: string;
  payer_email?: string | null;
};

export default function Pagos({
  subscription,
  userId,
}: {
  subscription: Subscription | null;
  userId: string;
}) {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);

  const isActive = subscription?.is_active === true;
  const status = subscription?.status;

  const handleOpenDialog = () => setOpenDialog(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEmail("");
    setError(null);
  };

  const handleSubscription = async () => {
    if (!email) {
      setError("Por favor, ingresa un email válido.");
      return;
    }

    try {
      const response = await fetch(`${options.api.url}mercadopago/subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // importante: mandamos user también (PK), así no dependés solo del email
        body: JSON.stringify({ email, user: userId || email }),
      });

      if (!response.ok) throw new Error("Error creando la suscripción.");

      const result = await response.json();
      window.open(result.init_point, "_blank");
      handleCloseDialog();
    } catch (error) {
      console.error("Error:", error);
      setError("Hubo un problema al crear la suscripción. Por favor, intenta nuevamente.");
    }
  };

  return (
    <Box>
      <Container
        id="container"
        sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", pt: { xs: 1, sm: 1 } }}
      >
        <Grid id="grid" container direction="row" justifyContent="center" alignItems="center">
          <Box>
            <Grid item xs={12}>
              <Box sx={{ paddingBottom: 1, display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                <Typography sx={{ paddingRight: 1, color: "white", fontSize: { sm: "2vw", xs: "3vw" } }}>
                  $ 23.000
                </Typography>

                <Button
                  type="button"
                  variant="contained"
                  disabled={isActive}
                  startIcon={<PaidIcon />}
                  sx={{
                    "&:disabled": { backgroundColor: "grey", color: gold[200] },
                    color: gold[200],
                    backgroundColor: "transparent",
                  }}
                  onClick={handleOpenDialog}
                >
                  {isActive ? "Suscripción activa" : "Subscribirse"}
                </Button>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Container>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="lg"
        PaperProps={{
          sx: {
            backgroundColor: "rgb(30, 35, 41)",
            color: "white",
            borderRadius: 2,
            padding: 2,
            width: "50%",
            height: "35%",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px", fontWeight: "bold", color: "white" }}>
          Ingresa tu email
        </DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!error}
            helperText={error}
            sx={{
              input: { color: "white" },
              label: { color: "rgba(255, 255, 255, 0.7)" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
                "&:hover fieldset": { borderColor: "white" },
              },
            }}
          />
          <Typography sx={{ paddingLeft: 1, color: "white", fontSize: { sm: "1rem", xs: "0.5rem" } }}>
            (Debe ser un mail válido de MercadoPago)
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} sx={{ color: "white" }}>
            Cancelar
          </Button>
          <ButtonBrand size="small" onClick={handleSubscription} variant="contained">
            Iniciar Sesión
          </ButtonBrand>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
